"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Storage = exports.StorageTypes = void 0;
var headers_1 = require("../../shared/headers");
var client_1 = require("../../shared/http/client");
exports.StorageTypes = __importStar(require("./types"));
var Storage = /** @class */ (function () {
    function Storage(apiUrl, appDetails, apiSecurity) {
        this.client = client_1.HttpClient.create(apiUrl, apiSecurity.unauthorizedCallback);
        this.appDetails = appDetails;
        this.apiSecurity = apiSecurity;
    }
    Storage.client = function (apiUrl, appDetails, apiSecurity) {
        return new Storage(apiUrl, appDetails, apiSecurity);
    };
    /**
     * Creates a new folder
     * @param payload
     */
    Storage.prototype.createFolder = function (payload) {
        var _a = this.client
            .postCancellable('/storage/folder', {
            parentFolderId: payload.parentFolderId,
            folderName: payload.folderName,
        }, this.headers()), promise = _a.promise, requestCanceler = _a.requestCanceler;
        return [promise, requestCanceler];
    };
    /**
     * Moves a specific folder to a new location
     * @param payload
     */
    Storage.prototype.moveFolder = function (payload) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.client
                        .post('/storage/move/folder', {
                        folderId: payload.folderId,
                        destination: payload.destinationFolderId,
                    }, this.headers())];
            });
        });
    };
    /**
     * Updates the metadata of a folder
     * @param payload
     */
    Storage.prototype.updateFolder = function (payload) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client
                            .post("/storage/folder/" + payload.folderId + "/meta", {
                            metadata: payload.changes,
                        }, this.headers())];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Fetches & returns the contents of a specific folder
     * @param folderId
     */
    Storage.prototype.getFolderContent = function (folderId) {
        var _a = this.client
            .getCancellable("/storage/v2/folder/" + folderId, this.headers()), promise = _a.promise, requestCanceler = _a.requestCanceler;
        return [promise, requestCanceler];
    };
    /**
     * Removes a specific folder from the centralized persistence
     * @param folderId
     */
    Storage.prototype.deleteFolder = function (folderId) {
        return this.client
            .delete("/storage/folder/" + folderId, this.headers());
    };
    /**
     * Returns the total size of a folder
     * @param folderId
     */
    Storage.prototype.getFolderSize = function (folderId) {
        return this.client
            .get("/storage/folder/size/" + folderId, this.headers())
            .then(function (response) {
            return response.size;
        });
    };
    /**
     * Creates a new file entry
     * @param fileEntry
     */
    Storage.prototype.createFileEntry = function (fileEntry) {
        return this.client
            .post('/storage/file', {
            file: {
                fileId: fileEntry.id,
                type: fileEntry.type,
                bucket: fileEntry.bucket,
                size: fileEntry.size,
                folder_id: fileEntry.folder_id,
                name: fileEntry.name,
                encrypt_version: fileEntry.encrypt_version,
            },
        }, this.headers());
    };
    /**
     * Updates the details of a file entry
     * @param payload
     */
    Storage.prototype.updateFile = function (payload) {
        return this.client
            .post("/storage/file/" + payload.fileId + "/meta", {
            metadata: payload.metadata,
            bucketId: payload.bucketId,
            relativePath: payload.destinationPath,
        }, this.headers());
    };
    /**
     * Deletes a specific file entry
     * @param payload
     */
    Storage.prototype.deleteFile = function (payload) {
        return this.client
            .delete("/storage/folder/" + payload.folderId + "/file/" + payload.fileId, this.headers());
    };
    /**
     * Updates the persisted path of a file entry
     * @param payload
     */
    Storage.prototype.moveFile = function (payload) {
        return this.client
            .post('/storage/move/file', {
            fileId: payload.fileId,
            destination: payload.destination,
            relativePath: payload.destinationPath,
            bucketId: payload.bucketId,
        }, this.headers());
    };
    /**
     * Returns a list of the n most recent files
     * @param limit
     */
    Storage.prototype.getRecentFiles = function (limit) {
        return this.client
            .get("/storage/recents?limit=" + limit, this.headers());
    };
    /**
     * Returns the current space usage of the user
     */
    Storage.prototype.spaceUsage = function () {
        return this.client
            .get('/usage', this.headers());
    };
    /**
     * Returns the current space limit for the user
     */
    Storage.prototype.spaceLimit = function () {
        return this.client
            .get('/limit', this.headers());
    };
    /**
     * Returns the needed headers for the module requests
     * @private
     */
    Storage.prototype.headers = function () {
        return (0, headers_1.headersWithTokenAndMnemonic)(this.appDetails.clientName, this.appDetails.clientVersion, this.apiSecurity.token, this.apiSecurity.mnemonic);
    };
    return Storage;
}());
exports.Storage = Storage;
